import { message } from 'antd';
import moment from 'moment';

import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { getGroupAdminDashboardCountsAPI } from '../../../services/dashboard-service';

import { FETCH_DASHBOARD, FETCH_DASHBOARD_START, FETCH_DASHBOARD_SUCCESS, FETCH_DASHBOARD_ERROR } from '../../actions/groupadmin/dashboardActions';

const initDashboardCounts = { worklist: 0, submittedToTypist: 0, parked: 0, submittedForVerification: 0, locked: 0 };

function* fetchDashboard({ }) {
    try {
        yield put({ type: FETCH_DASHBOARD_START });
        const response = yield call(getGroupAdminDashboardCountsAPI);
        if (response.success && response.data) {
            yield put({ type: FETCH_DASHBOARD_SUCCESS, dashboard: { ...initDashboardCounts, ...response.data } });
        } else {
            yield put({ type: FETCH_DASHBOARD_ERROR })
            message.error('Failed to fetch Dashboard!');
        }
    } catch (error) {
        yield put({ type: FETCH_DASHBOARD_ERROR, error })
        message.error('Failed to fetch Dashboard!');
    }
}

function* groupAdminDashboardWatcher() {
    yield takeLatest(FETCH_DASHBOARD, fetchDashboard)
}

export default function* rootSaga() {
    yield all([
        groupAdminDashboardWatcher(),
    ]);
}